import { render, staticRenderFns } from "./examHouseAddEdit.vue?vue&type=template&id=fe5a206c&scoped=true"
import script from "./examHouseAddEdit.vue?vue&type=script&lang=js"
export * from "./examHouseAddEdit.vue?vue&type=script&lang=js"
import style0 from "./examHouseAddEdit.vue?vue&type=style&index=0&id=fe5a206c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5a206c",
  null
  
)

export default component.exports